module.exports = __webpack_public_path__ + "static/media/app-icon.233b1603.png";